import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const ImageType = ApplicationRecord.extend({
  static: {
    jsonapiType: 'image_types',
  },
  attrs: {
    name: attr(),
    classname: attr(),
    printTemplateId: attr(),
    count: attr(),
    requiresBg: attr({ persist: false }),
    option: belongsTo(),
    component: belongsTo(),
  },
})

export default ImageType
